export default __webpack_public_path__ + "static/media/copy.86fe66bf.svg";